import { createPrefixedConstants } from 'app/common/CommonUtils';

export default createPrefixedConstants(
  'refresh',
  `
    UPDATE_RESOURCE_VERSION
  `
);
